import { Injectable } from '@angular/core';
import { WhitelabelConfigService } from './whitelabel-config.service';
import { WhitelabelConfigStore } from './whitelabel-config.store';
import { RuntimeThemeService } from './runtime-theme.service';
import { SeoService } from '../seo/seo.service';
import { AnalyticsService } from '../seo/analytics.service';
import { LEGACY_PAYMENT_FORM_STORAGE_KEY } from '../../payments/payment-flow.storage';

@Injectable({ providedIn: 'root' })
export class AppInitializationService {
  constructor(
    private configService: WhitelabelConfigService,
    private store: WhitelabelConfigStore,
    private theme: RuntimeThemeService,
    private seo: SeoService,
    private analytics: AnalyticsService
  ) {}

  initialize(): Promise<void> {
    // Remove payment snapshots created by older releases before any configured
    // third-party analytics script is allowed to execute.
    try {
      sessionStorage.removeItem(LEGACY_PAYMENT_FORM_STORAGE_KEY);
    } catch {
      // Storage can be unavailable in privacy-restricted browser contexts.
    }

    return this.configService.load().then(() => {
      const config = this.store.snapshot.config;
      if (config) {
        this.theme.apply(config);
        this.seo.apply(config);
        this.analytics.initialize(config.googleTagManagerId);
      }
    });
  }
}
